module.exports = __webpack_public_path__ + "static/media/UNIONPAY_INTERNATIONAL.ebcc776e.png";